import React, { useState } from "react";
import { ArrowLeft, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

import { requestPasswordReset } from "@/api/auth";
import LapstrLogo from "@/components/LapstrLogo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { isNativeApp } from "@/lib/runtime";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const native = isNativeApp();

  const onSubmit = async (event) => {
    event.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
      toast.success("E-post skickad", {
        description: "Om adressen finns registrerad skickas instruktioner för att återställa lösenordet.",
      });
    } catch (error) {
      toast.error("Kunde inte skicka e-post", {
        description: error?.message || "Försök igen om en stund.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={native ? "native-v3-public-flow" : "min-h-screen flex flex-col items-center justify-start sm:justify-center p-6"}>
      {native ? (
        <header className="native-v3-public-flow-header">
          <Link to="/auth" aria-label="Tillbaka till inloggning" className="native-v3-public-back">
            <ArrowLeft aria-hidden="true" />
          </Link>
          <div className="native-v3-public-brand">
            <img src="/icons/icon-512x512.png" alt="" aria-hidden="true" />
            <span>Lapstr</span>
          </div>
        </header>
      ) : (
        <div className="mx-auto mb-3 w-[min(92vw,560px)] sm:w-[min(90vw,620px)] md:w-[min(80vw,760px)]">
          <LapstrLogo className="w-full" outline={18} />
        </div>
      )}

      <main className={native ? "native-v3-public-flow-main" : "w-full max-w-sm bg-background shadow rounded-xl p-6 space-y-4"}>
        <div className={native ? "native-v3-public-flow-intro" : "space-y-1 text-center"}>
          {native ? <p className="native-v3-auth-kicker">KONTOHJÄLP</p> : null}
          <h1 className={native ? "native-v3-auth-title" : "text-xl font-semibold"}>{native ? "Återställ lösenord" : "Glömt lösenord?"}</h1>
          <p className={native ? "native-v3-auth-lead" : "text-sm text-muted-foreground"}>
            Ange din e-postadress så skickar vi en säker återställningslänk.
          </p>
        </div>

        {!sent ? (
          <form onSubmit={onSubmit} className={native ? "native-v3-auth-form" : "space-y-4"}>
            <div>
              <Label htmlFor="email">E-postadress</Label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                placeholder="din@adress.se"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </div>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "Skickar..." : "Skicka återställningslänk"}
            </Button>
          </form>
        ) : (
          <div className={native ? "native-v3-auth-sent" : "space-y-3 text-center text-sm text-muted-foreground"}>
            <Mail aria-hidden="true" />
            <h2>Kontrollera din inkorg</h2>
            <p>Om adressen finns registrerad skickas ett mejl med instruktioner för att välja ett nytt lösenord.</p>
            <p>Följ länken i mejlet inom en timme för att fortsätta.</p>
          </div>
        )}

        <div className={native ? "native-v3-public-flow-footer" : "pt-2 text-center text-sm"}>
          <Link to="/auth" className="text-primary font-medium hover:underline">
            Tillbaka till inloggning
          </Link>
        </div>
      </main>
    </div>
  );
}
